module.exports = __webpack_public_path__ + "img/logo2.35708da8.png";